if (!customElements.get('cart-terms')) {
  customElements.define(
    'cart-terms',
    class CartTerms extends HTMLElement {
      constructor() {
        super();

        this.termsToggle = document.querySelector('#terms');
        this.submitInput = document.querySelector('#checkout');
        this.isValid = this.submitInput.dataset.isValid === 'true';

        this.termsToggle.addEventListener(
          'input',
          function (event) {
            this.setSubmitInputDisabled();

            let formData = new FormData();
            formData.append('attributes[Terms agreed]', this.termsToggle.checked ? 'Yes' : 'No');

            fetch(window.Shopify.routes.root + 'cart/update.js', {
              method: 'POST',
              body: formData,
            });
          }.bind(this)
        );

        this.submitInput.addEventListener(
          'click',
          function (event) {
            if (!this.isValid || !this.termsToggle.checked) {
              event.preventDefault();
            }
          }.bind(this)
        );

        this.setSubmitInputDisabled();
      }

      setSubmitInputDisabled() {
        if (this.isValid && this.termsToggle.checked) {
          this.submitInput.removeAttribute('disabled');
        } else {
          this.submitInput.setAttribute('disabled', '');
        }
      }
    }
  );
}
